export default "__VITE_ASSET__CbxNuX4k__"